/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import UiFormInner from 'components/Forms/UIFormInner'
import UiButton, { UiButtonSize, UiButtonStyle, UiButtonType } from 'components/Ui/UiButton'
import { PlusIcon } from '@heroicons/react/24/solid'
import { UiTable, UiTableBody, UiTableContainer, UiTableHead, UiTableHeaderCell } from 'components/Ui/UiTable'
import EditCompanyModalLeadList from './EditCompanyModalLeadList'
import { Lead } from 'types/entities/Lead'

interface EditCompanyModalLeadsTabProps {
    leads: Lead[]
    onCreateLead?: () => void
    onLeadClick: (lead: Lead) => void
    title?: string
    createLabel?: string
}

const EditCompanyModalLeadsTab = ({
    leads,
    onCreateLead,
    onLeadClick,
    title,
    createLabel,
}: EditCompanyModalLeadsTabProps) => {
    const { t } = useTranslation()

    return (
        <div className={clsx('EditCompanyModalLeadsTab flex-1 flex flex-col pt-4 overflow-hidden')}>
            <UiFormInner
                title={title || t('Leads')}
                actions={onCreateLead ? (
                    <UiButton
                        onClick={onCreateLead}
                        style={UiButtonStyle.Primary}
                        size={UiButtonSize.Small}
                        type={UiButtonType.Button}
                        icon={<PlusIcon className={clsx('w-5 h-5')} />}
                    >
                        {createLabel || t('Create Lead')}
                    </UiButton>
                ) : undefined}
            >
                <UiTableContainer>
                    <UiTable>
                        <UiTableHead>
                            <UiTableHeaderCell align="left">{t('ID')}</UiTableHeaderCell>
                            <UiTableHeaderCell align="left">{t('Name')}</UiTableHeaderCell>
                            <UiTableHeaderCell align="left">{t('Status')}</UiTableHeaderCell>
                            <UiTableHeaderCell align="left">{t('Category')}</UiTableHeaderCell>
                        </UiTableHead>
                        <UiTableBody>
                            <EditCompanyModalLeadList
                                leads={leads}
                                onClick={onLeadClick}
                            />
                        </UiTableBody>
                    </UiTable>
                </UiTableContainer>
            </UiFormInner>
        </div>
    )
}

export default EditCompanyModalLeadsTab
